/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
const getRandomId = (prefix: string | number = ''): string => {
  return prefix + Math.random().toString(36).substr(2, 9);
};

export { getRandomId };
